import dynamic from 'next/dynamic';

const HomePage = dynamic(async () => import('@modules/home/home.page'), {
	ssr: false,
});

export default HomePage;
